import * as React from "react";

export const Mensaje = (props: MensajeProps) => (
    <div className={"alert alert-dismissible alert-" + props.type}>
        {props.mensaje}
    </div>
);

interface MensajeProps {
    type: string,
    mensaje: string
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/Mensaje.tsx